'use strict';

// ES6 class definition
export default class Filter {

  constructor() {
    let self = this;

    if (!document.querySelector('.filter') || document.querySelector('.filter--not-fixed')) {
      return false;
    }

    if (filterItemsMain.length > 0) {
      self.filterItemsMain = filterItemsMain;
    } else {
      return false;
    }

    if (filterItemsAdditional.length > 0) {
      self.filterItemsAdditional = filterItemsAdditional;
    } else {
      return false;
    }

    self.filteredItems = [];

    self.combinedArrays = self.filterItemsMain.concat(self.filterItemsAdditional);

    //console.log(self.filterItems);
  }


  go(debugMode = false) {

    let self = this;
    self._debugMode = debugMode;
    if (!document.querySelector('.filter') || document.querySelector('.filter--not-fixed')) {
      return false;
    }

    self.generateFilterList(self.filterItemsMain, '.filter__topics--main');
    self.generateFilterList(self.filterItemsAdditional, '.filter__topics--additional');
    self.initChangeListener();
    self.filterToArray();
    self.generateAddedFiltersInHeader();
    self.removeFromAddedFilters();
    self.changePositionOfResults();
    self.activeButtonOpenFilter();
  }

  generateFilterList(filterItems, listContainer) {
    let self = this;

    let filterList = document.querySelector(listContainer);

    // create new ul
    let ul = document.createElement('ul');
    ul.className += 'filter__topics-list';
    filterList.appendChild(ul);

    filterItems.forEach(function (item) {

      // create new li
      let li = document.createElement('li');
      li.dataset.item = item.id;
      li.className += 'checkbox-container';

      // create new input checkbox
      let input = document.createElement('input');
      input.type = 'checkbox';
      input.id = 'filter-topics-' + item.id;
      input.value = item.id;
      input.checked = item.selected;
      input.name = 'tx_solr[filter][]';
      input.className += 'opinion';
      input.checked = item.checked;
      // create new label
      let label = document.createElement('label');
      label.htmlFor = 'filter-topics-' + item.id;
      label.appendChild(document.createTextNode(item.value));

      ul.appendChild(li);
      li.appendChild(input);
      li.appendChild(label);

    });

  }

  filterToArray() {
    let self = this;

    let filter = document.querySelectorAll('.opinion'); // nodeList not working with forEach in IE
    filter = [].slice.call(filter); // convert it to an array for IE
    filter.forEach(function (el, index, array) {
      if (el.checked === true) {
        self.filteredItems.push(el.nextSibling.innerHTML);
      }
    });
    // self.generateAddedFiltersInHeader();
  }

  generateAddedFiltersInHeader() {
    let self = this;
    let filterHeadline = document.querySelector('.filter__headline');
    let filterChosen = document.querySelector('.filter__chosen');
    let filterChosenUL = document.querySelector('.filter__chosen ul');
    filterChosenUL.innerHTML = '';

    if (self.filteredItems.length <= 0) {
      filterHeadline.classList.add("animation-hide");
      filterChosen.classList.remove("animation-hide");
    } else {
      filterHeadline.classList.remove("animation-hide");
      filterChosen.classList.add("animation-hide");
    }

    self.filteredItems = [].slice.call(self.filteredItems); // convert it to an array for IE
    self.filteredItems.forEach(function (id) {
      let value = id;
      // create new li
      let li = document.createElement('li');

      // create new input checkbox
      let button = document.createElement('button');
      button.className += 'button topic';
      button.dataset.id = id;
      button.appendChild(document.createTextNode(value) ); // add checked text
      button.innerHTML += '<svg class="icon icon--small" style="margin-left: .5rem; width: .6rem; height: .6rem; vertical-align: 0px;"><use xlink:href="#icon-close"></use></svg>'; // add a icon close

      filterChosenUL.appendChild(li);
      li.appendChild(button);

    });

  }

  removeFromAddedFilters() {
    let self = this;

    if(document.querySelector('.button.topic')) {
      document.querySelector('.button.topic').onclick = function (ev) {
        self.deselectAll('.opinion');
        document.forms['filter'].submit();
        return false;
      }
    }

    // document.querySelector('.filter__chosen ul').onclick = function (ev) {
    //
    //   if (ev.target.type === 'submit') {
    //
    //     self.filteredItems = self.filteredItems.filter(item => item !== ev.target.dataset.id)
    //
    //     self.generateAddedFiltersInHeader();
    //     self.removeCheckedStatusFromCheckbox(ev.target.dataset.id);
    //   }
    //
    // }

  }

  getValueFromArray(id) {
    let self = this;
    let obj = self.combinedArrays.find(function (element) {
      return element.id == id;
    });
    return obj.value;
  }

  removeCheckedStatusFromCheckbox(id) {
    document.querySelector('.filter__topics-wrapper input[value="' + id + '"]').checked = false;
  }

  // Filter Stellungnahmen nach Themen, add a margin top in solrx results
  changePositionOfResults() {
    let idFilter = document.getElementById('filter'),
      solrxActive = document.getElementsByClassName('tx-solr').length,
      solrx = document.getElementsByClassName('tx-solr'),
      buttonMore = document.getElementsByClassName('filter__more-button'),
      activeFilter = document.querySelectorAll('.filter__chosen.animation-hide');
      
      if(window.innerWidth < 640) {
        idFilter.classList.add('smaller');
      }
      
      if (activeFilter.length) {
        idFilter.classList.add("active");
      } else {
        idFilter.classList.remove("active");
      }
    
    if (idFilter && solrxActive) {
      setTimeout(function () {
        solrx[0].style.marginTop = idFilter.offsetHeight + 'px';
      }, 1000);
      buttonMore[0].addEventListener('click', function () {
        setTimeout(function () {
          solrx[0].style.marginTop = idFilter.offsetHeight + 'px';
        }, 500);
      });
    }

  }

  changeListener(selector) {
    let self = this;
    $(selector).on('change', function (e) {

      let preventDefault = $(this).data('prevent-default');
      if (!preventDefault) {
        preventDefault = true;
      }
      self.deselectAll(selector);
      e.currentTarget.checked = true;
      document.forms['filter'].submit();
      return false;
    });

  }

  deselectAll(selector) {
    let items = document.querySelectorAll(selector); // nodeList not working with forEach in IE
    items = [].slice.call(items); // convert it to an array for IE
    items.forEach(function (el, index, array) {
      el.checked = false;
    });
  }

  activeButtonOpenFilter() {
    let buttonOpenFitler = document.querySelectorAll('.filter__open-button')[0],
    idFilter = document.getElementById('filter');

    buttonOpenFitler.addEventListener('click', function(event){
      
        idFilter.classList.remove("active");
        idFilter.classList.remove("smaller");
        event.preventDefault();
        return false;
    });
  }

  initChangeListener() {
    let self = this;
    self.changeListener('.opinion');
    self.changeListener('.year');


    // $.ajax({
    //   type: "POST",
    //   url: url,
    //   data: data,
    //   success: self.onSuccess($(this)),
    // }).done(function (resp) {
    //
    //   let modal = $('#generalModal');
    //   if (showResponseInModal === true) {
    //     modal.html(resp).foundation('open');
    //   }
    //
    //   if (showResponseInModal === true && redirectAfterCloseTriggered) {
    //     modal.on('closed.zf.reveal', function () {
    //       window.location.href = redirectAfterCloseTriggered;
    //     });
    //   }
    //
    //   if (loadResponseInElement) {
    //     let element = $(loadResponseInElement);
    //     element.html(resp)
    //   }
    //
    //   if (redirectAfterUrl) {
    //     window.location.href = redirectAfterUrl;
    //     window.location.reload(true);
    //   }
    // }).always(function (data) {
    //   self.flashMessagesModule.processFlashMessages(self, data);
    //   if (doNotShowLoadingIndicator !== true) {
    //     $('#loadingDiv').hide();
    //   }
    // });

    //document.forms['filter'].submit();
  }

}
